<div
  class="circle"
  [class.red]="circleColor == 'RED'"
  [class.green]="circleColor == 'GREEN'"
  [class.yellow]="circleColor == 'YELLOW'"
  [class.blue]="circleColor == 'BLUE'"
  [class.black]="circleColor == 'BLACK'"
  [class.large]="large"
  [class.small]="small"
  [class.t-pointer]="cnt > 0"
>
  <div class="center-el">
    <div
      class="cnt-lbl"
      [class.small]="small"
      [class.red]="circleColor == 'RED'"
      [class.green]="circleColor == 'GREEN'"
      [class.yellow]="circleColor == 'YELLOW'"
      [class.blue]="labelColor == 'BLUE'"
    >
      {{ cnt }}
    </div>
    <div class="txt-lbl" [class.small]="small">{{ label }}</div>

    <div
      *ngIf="pct && pct != 0"
      class="pct-lbl"
      [class.red]="deltaColor == 'RED'"
      [class.green]="deltaColor == 'GREEN'"
      [class.large]="large"
    >
      {{ pct | percent }}
      <i
        class="fas"
        [class.fa-arrow-up]="arrowType == 'UP'"
        [class.fa-arrow-down]="arrowType == 'DOWN'"
      ></i>
    </div>

    <div
      *ngIf="deltaCnt && deltaCnt != 0"
      class="pct-lbl"
      [class.red]="deltaColor == 'RED'"
      [class.green]="deltaColor == 'GREEN'"
      [class.large]="large"
    >
      {{ deltaCnt }}
      <i
        class="fas"
        [class.fa-arrow-up]="arrowType == 'UP'"
        [class.fa-arrow-down]="arrowType == 'DOWN'"
      ></i>
    </div>
  </div>
</div>
